<template>
  <div>
    <span v-if="field.label" class="subheading primary--text font-weight-medium text-uppercase">
      {{ field.label }}
    </span>
    <v-divider />
    <span v-if="field.hint" class="text-caption">{{ field.hint }}</span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DynamicDivider',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  }
})
</script>